import React from 'react'
import './Widgets.css';
import InfoIcon from '@material-ui/icons/Info';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

function Widgets() {

    const newsArticle = (heading, subtitle) => (
        <div className="widgets__article">
            <div className="widgets__articleLeft">
                <FiberManualRecordIcon/>
            </div>
            <div className="widgets__articleRight">
                <h4>{heading}</h4>
                <p>{ subtitle}</p>
            </div>
        </div>
    )

    return (
        <div className="widgets">
            

            {newsArticle("Being lesbian or gay or bisexual or trans is not something that one chooses; it is simply a part of who we are." ,"-Melissa Etheridge")}
            {newsArticle("Gender and sexual orientation are not binary concepts. There is a whole spectrum of identities and experiences, and it's important to respect and honor them all.","-Laverne Cox")}
            {newsArticle("Pride is not about being better than others, it's about celebrating who we are and the progress we've made." ,"-Unknown")}

        </div>
    );
}

export default Widgets;
